import React, { Component } from 'react';
import { isEmpty, size } from "lodash";

import { EditRounded, DeleteRounded, CloudDownloadRounded } from '@mui/icons-material';
import { IconButton, 
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination, 
} from '@mui/material';
import PaymentDetails from './PaymentDetails';
import PaymentForm from './PaymentForm';
import Pagination from '../../../container/MUI/Pagination';
import Currency from '../../common/Currency';
import DeleteDialog from '../../common/DeleteDialog';
import TitleWithEndAction from '../../common/TitleWithEndAction';


class PaymentsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        openDelete: false,
        selected: {},
        searchBank: "",
        searchBar: "",
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleClose = () => {
		this.setState({ 
            openForm: false,
            openDetails: false,
            openUpdate: false,
            openDelete: false,
            selected: {},
        });
    };    
    filterList = () => {
        const { searchBank, searchBar, searchMode, searchUser, PAYMENTS } = this.props;
        let list = Object.values(PAYMENTS)
        // list = list.filter(item => item.payment_mode !== "ACOMPTE" )
        list = list.filter(item => item.payment_mode !== "")
        // if( !isEmpty(searchBank) ){
        //     list = list.filter( item => item.payment_bank === searchBank)
        // }
        if( !isEmpty(searchBank.value)) {
            list = list.filter( item => item.payment_bank === searchBank.value)
        }
        if( Array.isArray(searchBank) && !isEmpty(searchBank) ) {
            let itemList = searchBank.map(item => item.value )
            list = list.filter( item => itemList.includes(item.payment_bank))
        }

        if( !isEmpty(searchBar) ){
            list = list.filter( item => item.payment_ref.toLowerCase().includes(searchBar.toLocaleLowerCase()))
        }
        if( !isEmpty(searchMode?.value) ){
            list = list.filter( item => item.payment_mode === searchMode.value)
        }
        if( Array.isArray(searchMode) && !isEmpty(searchMode) ) {
            let itemList = searchMode.map(item => item.value )
            list = list.filter( item => itemList.includes(item.payment_mode))
        }
        // if( !isEmpty(searchUser) ){
        //     list = list.filter( item => item.payment_user === searchUser)
        // }
        if( !isEmpty(searchUser.value)) {
            list = list.filter( item => item.payment_user === searchUser.value)
        }
        if( Array.isArray(searchUser) && !isEmpty(searchUser) ) {
            let itemList = searchUser.map(item => item.value )
            list = list.filter( item => itemList.includes(item.payment_user))
        }

        return list
    }
    getPaymentsList = (list) => {
        const { rowsPerPage, page } = this.state;
        const { BANKS, isSuper } = this.props;
        let paymentIDS = []
        // let creditIDS = []
        list.forEach(item => {
            if(!isEmpty(BANKS) && !BANKS[item.payment_bank] ){
                console.log("ERROR PAYMENT BANK", item.payment_date, item.payment_mode, item.payment_id, BANKS[item.payment_bank]);
                paymentIDS.push({payID: item.payment_id, mode: item.payment_mode, creditID: item.payment_credit})
            }
        })
        console.log({paymentIDS});
        if (!isEmpty(list)){

            // return Object.values(PAYMENTS).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
                <TableRow hover key={item.payment_id} className="clickable" title="Voir le Détail">
                
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: item}) } >
                        {item.payment_id.slice(0, 18)}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: item}) } >
                        {new Date(item.payment_date).toLocaleDateString("fr-FR")}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: item}) } >
                        {!isEmpty(BANKS) && BANKS[item.payment_bank] && BANKS[item.payment_bank].bank_name}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: item}) } >
                        <Currency value={item.payment_total_amount} />
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: item}) } >
                        {item.payment_mode}{item.is_supplier_advance && " - ACOMPTE"}{item.is_avance && " - AVANCE"}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: item}) } >
                        {item.payment_ref}
                    </TableCell>                     
                    {/* { isSuper && */}
                    <TableCell onClick={ () => this.setState({openUpdate: true, selected: item}) }>
                        {!item.is_avance &&
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <EditRounded />
                            </IconButton> 
                        }
                    </TableCell>      
                   {/* } */}
                    {/* { isSuper && */}
                    <TableCell onClick={ () => this.setState({openDelete: true, selected: item}) }>
                        {!item.is_supplier_advance && !item.is_avance &&
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <DeleteRounded />
                            </IconButton> 
                        }
                    </TableCell>      
                   {/* } */}

                </TableRow>
            ) )
        }
    }
    handleDelete = async (selected = this.state.selected) => {
        // const { selected } = this.state;
        await this.props.deletePayment(selected)
        if(this.props.STATE.payments.error){
            this.props.notif("error", this.props.STATE.payments.error)
        } else {
            this.props.notif("success", "Paiement supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
    render() {
        const { openDetails, rowsPerPage, page, openUpdate, openDelete, selected } = this.state;
        const { BANKS } = this.props;

        let payList = this.filterList()
        return (
            <div>
                {openDetails &&
                    <PaymentDetails 
                        open={openDetails} 
                        handleClose={this.handleClose} 
                        payment={selected}
                        {...this.props} 
                    />
                }
                {openUpdate && !isEmpty(selected) &&
                    <PaymentForm 
                        update 
                        payment={selected} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"le Paiement"}
                        close={this.handleClose}
                        notif={this.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.payments.fetching}
                    >
                        Paiement du {new Date(selected.payment_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.payment_total_amount} />
                    </DeleteDialog>
                }
                {/* <Box p={1}>
                    <Typography variant="h6" id="tableTitle">
                        Liste des Paiements
                    </Typography>

                    <Box style={{textAlign: "right"}}>
                        <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/payments")} title="Télécharger" disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                    </Box>
                </Box> */}
                {/* <TitleWithEndAction
                    title="Liste des Paiements"
                    action={() => this.props.openFormDownload("/extract/payments")}
                    actionTitle="Télécharger" 
                    disabled={this.props.downloading}
                /> */}
                <Box p={2} >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Banque</TableCell>
                                <TableCell>Montant</TableCell>
                                <TableCell>Mode</TableCell>
                                <TableCell>Ref</TableCell>
                                <TableCell>Modifier</TableCell>
                                <TableCell>Supprimer</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.getPaymentsList(payList)}
                        </TableBody>
                        {size(payList) > 20 &&
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[20, 50]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={8}
                                        count={size(payList)}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        }
                    </Table> 
                </Box>
            </div>
        );
    }
}

export default PaymentsList;


// {payID: '5e1b98da-8f13-4ace-8686-35cf5700404d', mode: 'MOBILE MONEY', creditID: '07c968be-3608-4556-b821-04585c59cdfe'}
// {payID: 'b264b87f-1cfd-4cdd-bcad-51e16d151e71', mode: 'MOBILE MONEY', creditID: 'ed426f39-a323-46ce-8979-de036d8df67b'}
// {payID: 'c3fa9895-04e9-440c-ae97-02d331a2bcbc', mode: 'MOBILE MONEY', creditID: 'a031a9e4-1886-4598-a9e6-7337869aaeef'}
// {payID: '445fc87d-51c3-4c0b-8bdc-524343aa085e', mode: 'MOBILE MONEY', creditID: 'cdcadc67-8c03-4edd-85db-6e3f51e20979'}
// {payID: 'c188b196-4a03-43ce-a7ae-6ae08709ea42', mode: 'MOBILE MONEY', creditID: '9af11ac2-72b1-437a-a1a2-833af930d0ef'}
// {payID: '0cc20186-2d1b-41da-83d3-353d5fd0901a', mode: 'MOBILE MONEY', creditID: '662e7d85-edcb-4b8c-b197-0e97112a79ab'}
// {payID: 'a4952474-af69-422d-be11-331f8e92acae', mode: 'COLLAB'}
// {payID: 'ecbcc6d2-daef-4858-8d55-9be8b6f2fcda', mode: 'COLLAB'}